var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"explain"},[_c('h1',[_vm._v("帳號聲明")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.association.explain)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }